import React from 'react';
import { useConfigStore } from '../../Stores/Config';

const calculateShadeColor = function (col: any, amt: any) {
    col = col.replace(/^#/, "");
    if (col.length === 3)
        col = col[0] + col[0] + col[1] + col[1] + col[2] + col[2];

    let [r, g, b] = col.match(/.{2}/g);
    [r, g, b] = [
        parseInt(r, 16) + amt,
        parseInt(g, 16) + amt,
        parseInt(b, 16) + amt,
    ];

    r = Math.max(Math.min(255, r), 0).toString(16);
    g = Math.max(Math.min(255, g), 0).toString(16);
    b = Math.max(Math.min(255, b), 0).toString(16);

    const rr = (r.length < 2 ? "0" : "") + r;
    const gg = (g.length < 2 ? "0" : "") + g;
    const bb = (b.length < 2 ? "0" : "") + b;

    return `#${rr}${gg}${bb}`;
};

const calculateContrast = (hex: any) => {
    var r = parseInt(hex.substr(1, 2), 16),
        g = parseInt(hex.substr(3, 2), 16),
        b = parseInt(hex.substr(5, 2), 16),
        yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 160 ? "#000000" : "#ffffff";
};

function CSSInjector() {
    const configStore = useConfigStore();
    const primaryColor = configStore.getUIColor();
    const backgroundColor = configStore.getBackgroundColor();
    const buttonColor = configStore.getButtonColor();
    const headerColor = configStore.getHeaderColor();
    const customCSS = configStore.config.customCSS;
    
    const contrastColor = calculateContrast(primaryColor);
    const contrastHeaderColor = calculateContrast(headerColor);
    const contrastButtonColor = calculateContrast(buttonColor);
    const contrastBackgroundColor = calculateContrast(backgroundColor);
    const isDarkMode = contrastBackgroundColor === "#ffffff";
    const subTextColor = isDarkMode
        ? calculateShadeColor(backgroundColor, 100)
        : calculateShadeColor(backgroundColor, -120);
    const backgroundColorHover = isDarkMode
        ? calculateShadeColor(backgroundColor, 30)
        : calculateShadeColor(backgroundColor, -12);
    const hoverHoverColor = isDarkMode
        ? calculateShadeColor(backgroundColor, 80)
        : calculateShadeColor(backgroundColor, -30);
    const borderColor = isDarkMode
        ? calculateShadeColor(backgroundColor, 70)
        : calculateShadeColor(backgroundColor, -70);

    const css = `
    :root {
        --primary-color: ${primaryColor};
        --primary-color-20: ${primaryColor}20;
        --primary-color-66: ${primaryColor}66;
        --header-color: ${headerColor};
        --button-color: ${buttonColor};
        --background-color: ${backgroundColor};
        --primary-contrast-color: ${contrastColor};
        --header-contrast-color: ${contrastHeaderColor};
        --button-contrast-color: ${contrastButtonColor};
        --primary-text-color: ${contrastBackgroundColor};
        --secondary-text-color: ${subTextColor};
        --background-color-darker: ${backgroundColorHover};
        --background-color-dark: ${hoverHoverColor};
        --border-color: ${borderColor};
        --border-radius: ${configStore.getBorderRadius(1.0)}px;
        --border-radius-150: ${configStore.getBorderRadius(1.50)}px;
        --border-radius-60: ${configStore.getBorderRadius(0.6)}px;
        --border-radius-40: ${configStore.getBorderRadius(0.4)}px;
        --border-radius-25: ${configStore.getBorderRadius(0.25)}px;
    }
    `;

    return (
        <>
            <style>{css}</style>
            {customCSS && <style>{customCSS}</style>}
        </>
    );
}

export default CSSInjector;